import {hasString} from '~/utils/obj';
import type {EtherSeo} from '~/interfaces/seo';

export const getCanonical = (seo: EtherSeo) => {
    if (seo?.advanced && hasString(seo.advanced, 'canonical')) {
        return { rel: 'canonical', href: seo.advanced.canonical };
    }
    return false;
};
